import React from "react";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import EmptyBoxIcon from "@assets/icons/empty-box.svg";
import { TextWithBreaks } from "@ui/components/common/text-with-breaks";

export const EmptySearch: React.FC = () => {
	const { format } = useI18n();

	return (
		<Container>
			<EmptyBoxIcon width={128} height={128} />
			<Content>
				<h3>{format("exerciseListing.emptySearch.title")}</h3>
				<TextWithBreaks text={format("exerciseListing.emptySearch.description")} />
			</Content>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 24px;
`;

const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	text-align: center;
`;
